const APP_CONFIG = {
  version: "7.51.2",
  title: "Claire V7.51.2",
  version_client: "7.51.2",
};

export default APP_CONFIG;
